/* unplugin-vue-components disabled */import script from "./CourseDesignDetailTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseDesignDetailTop.vue?vue&type=script&lang=ts&setup=true"

import "./CourseDesignDetailTop.vue?vue&type=style&index=0&id=46cba2cc&scoped=true&lang=css"
import "./CourseDesignDetailTop.vue?vue&type=style&index=1&id=46cba2cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46cba2cc"]])

export default __exports__